<template>
<div>
  <el-card body-style="padding: 0">
    <el-form ref="queryForm" :model="queryForm" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="5">
          <el-form-item label="用户账号" prop="userName">
            <el-input v-model="queryForm.userName" placeholder="请输入用户账号"/>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="订单号" prop="orderId">
            <el-input v-model="queryForm.orderId" placeholder="请输入系统订单号"/>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="任务编号" prop="taskId">
            <el-input v-model="queryForm.taskId" placeholder="请输入任务编号"/>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="交易类型" prop="serialType">
            <el-select v-model="queryForm.serialType" clearable placeholder="请选择交易类型">
              <el-option
                  v-for="item in serialTypeEnum"
                  :key="item.serialType"
                  :label="item.serialTypeName"
                  :value="item.serialType"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!--<el-col :span="5">
          <el-form-item label="操作人" prop="optUser">
            <el-input v-model="queryForm.userName" placeholder="请输入操作人"/>
          </el-form-item>
        </el-col>-->
      </el-row>
      <el-row>
        <el-col :span="5">
        <el-form-item label="用户类型" prop="userType">
          <el-select v-model="queryForm.userType" clearable placeholder="请选择用户类型">
            <el-option
                v-for="item in allUserType"
                :key="item.id"
                :label="item.userTypeName"
                :value="item.userTypeName"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
        <!--<el-col :span="5">
        <el-form-item label="账户类型" prop="accountType">
          <el-select v-model="queryForm.accountType" clearable placeholder="请选择账户类型">
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>-->
        <el-col :span="6">
          <el-form-item label="时间段" prop="timeRange">
            <el-date-picker
                v-model="queryForm.timeRange"
                type="daterange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <el-button type="primary" size="small"
                       @click="submitQueryForm()" icon="el-icon-search">
              查询</el-button>
            <el-button type="primary" size="small" plain
                       @click="resetQueryForm()" icon="el-icon-refresh">
              重置</el-button>
            <el-button type="primary" size="small" plain
                       @click="exportsMoneyChangeList()" icon="el-icon-refresh">
              导出</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>

  <el-card>
    <el-table :data="tableData"
              border default-expand-all stripe
              :header-cell-style="{'text-align':'center'}"
              :cell-style="{'text-align':'center'}"
              :max-height="tableHeight"
              style="width: 100%;margin-bottom: 20px;">
      <el-table-column prop="serialDate" label="时间" />
      <el-table-column prop="serialNumber" label="交易流水号" />
      <el-table-column prop="userType" label="用户类型" />
      <el-table-column prop="userName" label="用户账号" min-width="100%">
        <!--<template slot-scope="scope">
          <span>{{getStrEndWithNumbers(scope.row.b2cUsersId)}}</span>
        </template>-->
      </el-table-column>
      <el-table-column prop="serialTypeEnumStr" label="交易类型" />
      <el-table-column prop="orderNumbers" label="订单编号" min-width="100%">
        <!--<template slot-scope="scope">
          <span>{{getStrEndWithNumbers(scope.row.b2cOrderId)}}</span>
        </template>-->
      </el-table-column>
      <el-table-column prop="b2cTasksId" label="任务编号" min-width="100%">
        <!--<template slot-scope="scope">
          <span>{{getStrEndWithNumbers(scope.row.b2cTasksId)}}</span>
        </template>-->
      </el-table-column>
      <el-table-column prop="serialMoney" label="金额" />
      <el-table-column prop="balanceMoney" label="余额" />
      <el-table-column prop="moneyChangeTypeStr" label="类型" />
      <el-table-column prop="accountType" label="账户类型" />
      <el-table-column prop="remarks" label="备注" />
    </el-table>
    <el-pagination
        :page-sizes="[20, 50, 100, 200]"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        @size-change="handlePageSizeChange"
        @current-change="handlePageNumChange"
        background
        style="float: right;margin-bottom: 10px">
    </el-pagination>
  </el-card>
</div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD'
import {
  exportDataFromService,
  getAdminAccountChangeMoneyChart
} from "../../api/b2cbusiness/b2c_investmoney";
import {getAllUserType} from "../../api/b2cbusiness/b2c_admin";
import qs from	'qs'
import MinxinScroll from "@/components/MinxinScroll";
export default {
  name: "MoneyChangeLoglist",
  mixins:[MixinCUD, MinxinScroll],
  data(){
    return {
      serialTypeEnum:[
        {
          serialTypeName:"后置评价结算",
          serialType:2021080001
        },
        {
          serialTypeName:"上级奖励",
          serialType:2021080002
        },
        {
          serialTypeName:"佣金奖励",
          serialType:2021080003
        },
        {
          serialTypeName:"账户充值",
          serialType:2021080005
        },
        {
          serialTypeName:"账户提现",
          serialType:2021080004
        },
        {
          serialTypeName:"本金返还",
          serialType:2021110004
        },
        {
          serialTypeName:"佣金返还",
          serialType:2021110005
        },
        {
          serialTypeName:"手动结算",
          serialType:2021110007
        },
        {
          serialTypeName:"手动调整",
          serialType:2023060701
        },
        {
          serialTypeName:"推荐奖励",
          serialType:2022010007
        },
        {
          serialTypeName:"发布任务",
          serialType:2021080006
        }
      ],
      allUserType:[],
      tableData:[],
      queryFormRefName:"queryForm",
      queryForm:{
        userName: '',
        orderId: null,
        taskId : null,
        serialType: null,
        userType: null,
        timeRange: null
      },
      tableHeight: 850,
      pagination:{
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 320;
    //console.log(document.body.clientHeight, this.tableHeight)
  },
  mounted() {
    getAllUserType().then(res=>{
      if (res.success){
        console.log(res.data)
        this.allUserType = res.data;
      }
    });
    this.getData();
  },
  methods: {
    exportsMoneyChangeList(){
      window.open("https://api.weiquanai.com/accountchangerecords/exportdata?"+qs.stringify({
        orderId: this.queryForm.orderId,
        userName: this.queryForm.userName,
        taskId: this.queryForm.taskId,
        serialType: this.queryForm.serialType,
        userType: this.queryForm.userType,
        startTime: this.queryForm.timeRange?this.queryForm.timeRange[0]:null,
        endTime: this.queryForm.timeRange?this.queryForm.timeRange[1]:null,
        pageNum: -1,
        pageSize: -1,
      }), "_blank");
      /*
      exportDataFromService(this.queryForm, {pageNum: -1, pageSize: -1}, (env)=>{
        this.dialogFormVisible = true;
        let progressBar = Math.round( env.loaded / env.total*100);
        //接收进度为99%的时候需要留一点前端编译的时间
        if(progressBar >= 99){
          this.percentage = 99;
          this.title = '下载完成，文件正在编译。';
        }else{
          this.percentage = progressBar;
          this.title = '正在下载，请稍等。';
        }
      }).then(res=>{
        console.log(res.data)
        if (res.success){
          this.dialogFormVisible = false;
          let blob = new Blob([response.data], {
            // 这里一定要和后端对应，不然可能出现乱码或者打不开文件
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName)
          } else {
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'test.xlsx'; // 在前端也可以设置文件名字
            link.click();
            //释放内存
            window.URL.revokeObjectURL(link.href)
          }
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });

       */
    },
    /*getStrEndWithNumbers(numbers) {
      if (numbers != null && numbers.length > 0){
        return getStrEndWithNumbers(numbers, 8);
      }
    },

     */
    getData(){
      getAdminAccountChangeMoneyChart(this.queryForm, this.pagination).then(res=>{
        if (res.success){
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      });
    },
    handlePageSizeChange(val){
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val){
      this.pagination.pageNum = val;
      this.submitQueryForm()

      //切换页面恢复到顶部
      this.scrollTop = 0
      this.saveScroll()
    },
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}
</style>
